import axios from "axios";
import { Auth } from "./authService";
const { BACKEND_URL } = require("../config/config");

const authController = new Auth();

export async function obtenerListaDeUsuarios(orderByField = "nombre", orderByDirection = "asc") {
  const token = authController.getAccessToken();
  const url = `${BACKEND_URL}/usuario?order=${orderByField}&dir=${orderByDirection}`;

  return axios.get(url, {
    headers: {
      Authorization: token,
    },
  });
}

export async function obtenerPermisosDeUsuario(id) {
  const token = authController.getAccessToken();
  const url = `${BACKEND_URL}/permisosDeUsuario/${id}`;

  return axios.get(url, {
    headers: {
      Authorization: token,
    },
  });
}

export async function homologarUsuario(id, value) {
  const token = authController.getAccessToken();
  const url = `${BACKEND_URL}/homologarUsuario/${id}`;

  return axios.put(
    url,
    { value },
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }
  );
}

export async function actualizarUsuario(userData) {
  const token = authController.getAccessToken();
  const url = `${BACKEND_URL}/usuario/${userData.id_usuario}`;

  try {
    const response = await axios.put(url, userData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    const status = error.response?.status;
    const message = error.response?.data?.message || "Error al actualizar el usuario.";

    // Construir un error personalizado con código
    const customError = new Error(message);
    customError.status = status;
    throw customError;
  }
}

export async function actualizarPassword(userData) {
  const token = authController.getAccessToken();
  const url = `${BACKEND_URL}/updatePassword/${userData.id_usuario}`;
  return axios.put(
    url,
    userData,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }
  );
}

export async function resetPasswordWithToken(userData) {
  const token = authController.getAccessToken();
  const url = `${BACKEND_URL}/updatePasswordWithToken`;
  return axios.post(
    url,
    userData,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }
  );
}

export async function recuperarPassword(userData) {
  const token = authController.getAccessToken();
  const url = `${BACKEND_URL}/recuperarPassword`;

  return axios.post(
    url,
    userData,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }
  );
}

export async function crearUsuario(userData) {
  const token = authController.getAccessToken();
  const url = `${BACKEND_URL}/usuario`;

  return axios.post(
    url,
    userData,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }
  );
}

export async function eliminarUsuario(id) {
  const token = authController.getAccessToken();
  const url = `${BACKEND_URL}/usuario/${id}`;

  return axios.delete(
    url,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }
  );
}

export async function getDocumentosDeUsuario(idUsuario) {
  try {
    const token = authController.getAccessToken();
    const url = `${BACKEND_URL}/documentosdeusuario/${idUsuario}`;
    return axios.get(url, {
      headers: {
        Authorization: token,
      },
    });
  } catch (error) {
    console.log("error al obtener documentos aprobados por expediente", error);
    throw error;
  }
}

export async function updateDocumentosDeUsuario(id_usuario, documentos) {
  const token = authController.getAccessToken();
  const url = `${BACKEND_URL}/updateDocumentosDeUsuario/${id_usuario}`;

  return axios.put(
    url,
    { files: documentos },
    {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }
  );
}

export async function getOficinasDeUsuario(idUsuario) {
  try {
    const token = authController.getAccessToken();
    const url = `${BACKEND_URL}/oficinasDeUsuario/${idUsuario}`;
    return axios.get(url, {
      headers: {
        Authorization: token,
      },
    });
  } catch (error) {
    console.log("error al obtener documentos aprobados por expediente", error);
    throw error;
  }
}
